import { createAsyncSelectors } from '@lib/selectors';
import { useAction } from '../useAction';
import { useSonarSelector } from '../useSonarSelector';
import { coreActions } from '@sonar-software/sonar-core';
const selectors = createAsyncSelectors((state) => state.core.initiatives.sonarObjects.delete);
/**
 * Subscribes to the remove from initiative processing. Provides actions to request and reset, and flags for status.
 * @returns A {@link UseRemoveFromInitiativeResult} with processing flags and actions.
 */
export function useRemoveFromInitiative() {
    const request = useAction(coreActions.requestDeleteCoreInitiativesSonarObjects);
    const reset = useAction(coreActions.resetDeleteCoreInitiativesSonarObjects);
    const isProcessing = useSonarSelector(selectors.isRequested);
    const isSuccessful = useSonarSelector(selectors.isReceived);
    return {
        isProcessing,
        isSuccessful,
        request,
        reset
    };
}
useRemoveFromInitiative.selectors = selectors;
